import type * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProjectReportsListQueryVariables = Types.Exact<{
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ProjectReportsListQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly id: string, readonly projectReports?: ReadonlyArray<{ readonly __typename?: 'ProjectReport', readonly id: string, readonly periodStart: string, readonly periodEnd: string, readonly status: Types.ProjectReportStatus, readonly generatedAt?: string | null, readonly errorReason?: Types.ProjectReportErrorReason | null, readonly company: { readonly __typename?: 'AccountsCompany', readonly id: string, readonly name: string }, readonly reportData?: { readonly __typename?: 'ProjectReportData', readonly project: { readonly __typename?: 'ProjectReportProject', readonly score?: number | null, readonly scoreZone?: Types.ProjectReportScoreZoneKey | null } } | null }> | null } | null };


export const ProjectReportsListDocument = gql`
    query ProjectReportsList($limit: Int, $offset: Int) {
  currentUser {
    id
    projectReports(limit: $limit, offset: $offset) {
      id
      periodStart
      periodEnd
      status
      generatedAt
      errorReason
      company {
        id
        name
      }
      reportData {
        project {
          score
          scoreZone
        }
      }
    }
  }
}
    `;

/**
 * __useProjectReportsListQuery__
 *
 * To run a query within a React component, call `useProjectReportsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectReportsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectReportsListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useProjectReportsListQuery(baseOptions?: Apollo.QueryHookOptions<ProjectReportsListQueryPage, ProjectReportsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectReportsListQueryPage, ProjectReportsListQueryVariables>(ProjectReportsListDocument, options);
      }
export function useProjectReportsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectReportsListQueryPage, ProjectReportsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectReportsListQueryPage, ProjectReportsListQueryVariables>(ProjectReportsListDocument, options);
        }
export function useProjectReportsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectReportsListQueryPage, ProjectReportsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectReportsListQueryPage, ProjectReportsListQueryVariables>(ProjectReportsListDocument, options);
        }
export type ProjectReportsListQueryHookResult = ReturnType<typeof useProjectReportsListQuery>;
export type ProjectReportsListLazyQueryHookResult = ReturnType<typeof useProjectReportsListLazyQuery>;
export type ProjectReportsListSuspenseQueryHookResult = ReturnType<typeof useProjectReportsListSuspenseQuery>;
export type ProjectReportsListQueryResult = Apollo.QueryResult<ProjectReportsListQueryPage, ProjectReportsListQueryVariables>;